// Australian Pharmaceutical Wholesalers & Suppliers
export const suppliers = [
  {
    id: 'SYM',
    name: 'Symbion Pty Ltd',
    type: 'Primary Wholesaler',
    parent: 'EBOS Group',
    phone: '1300 724 777',
    email: 'orders@symbion.com.au',
    orderPlatform: 'Symbion Online / S-Link',
    leadTimeDays: { metro: 1, regional: 3 },
    deliveryDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    orderCutoff: '14:00',
    statOrderCutoff: '11:00',
    paymentTerms: 'Net 30',
    settlementDiscount: 2.5,
    volumeRebate: '1.0% - 3.0%',
    csoFunded: true,
    accountNumber: 'SYM-MFC-001',
  },
  {
    id: 'API',
    name: 'Australian Pharmaceutical Industries',
    type: 'Primary Wholesaler',
    parent: 'Wesfarmers',
    phone: '1300 369 274',
    email: 'orders@api.net.au',
    orderPlatform: 'MyAPI / API Connect',
    leadTimeDays: { metro: 1, regional: 3 },
    deliveryDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    orderCutoff: '15:00',
    statOrderCutoff: '10:30',
    paymentTerms: 'Net 30',
    settlementDiscount: 2.5,
    volumeRebate: '0.5% - 2.5%',
    csoFunded: true,
    accountNumber: 'API-MFC-002',
  },
  {
    id: 'SIG',
    name: 'Sigma Healthcare Ltd',
    type: 'Primary Wholesaler',
    parent: 'Sigma Healthcare (ASX: SIG)',
    phone: '1800 008 215',
    email: 'orders@sigmahealthcare.com.au',
    orderPlatform: 'Sigma Connect',
    leadTimeDays: { metro: 1, regional: 2 },
    deliveryDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    orderCutoff: '14:30',
    statOrderCutoff: '10:00',
    paymentTerms: 'Net 30',
    settlementDiscount: 2.5,
    volumeRebate: '1.0% - 2.0%',
    csoFunded: true,
    accountNumber: 'SIG-MFC-003',
  },
  {
    id: 'CH2',
    name: 'CH2 (Chemist Holdings)',
    type: 'Cooperative Wholesaler',
    parent: 'Member-owned cooperative',
    phone: '1300 424 262',
    email: 'orders@ch2.net.au',
    orderPlatform: 'CH2 Online',
    leadTimeDays: { metro: 1, regional: 4 },
    deliveryDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    orderCutoff: '14:00',
    statOrderCutoff: '11:00',
    paymentTerms: 'Net 30',
    settlementDiscount: 2.0,
    volumeRebate: '0.5% - 1.5%',
    csoFunded: true,
    accountNumber: 'CH2-MFC-004',
  },
  {
    id: 'LEX',
    name: 'Lexon (Aust) Pty Ltd',
    type: 'Short-line Wholesaler',
    parent: 'Lexon',
    phone: '1300 539 668',
    email: 'orders@lexon.com.au',
    orderPlatform: 'Lexon Online',
    leadTimeDays: { metro: 2, regional: 5 },
    deliveryDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    orderCutoff: '12:00',
    statOrderCutoff: null,
    paymentTerms: 'Net 14',
    settlementDiscount: 3.0,
    volumeRebate: '1.0% - 2.0%',
    csoFunded: false,
    accountNumber: 'LEX-MFC-005',
  },
];
